<div>
  <app-titlebar #titlebar>
  </app-titlebar>
</div>
<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="條件設定">
    <mat-toolbar class="h-9">
      <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doQuery()">
        <mat-icon fontIcon="search"></mat-icon>查詢
      </button>
      <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="doGetPreFilter()">
        <mat-icon fontIcon="search"></mat-icon>取前次
      </button>
    </mat-toolbar>

    <div class="csv-reader">
      <button mat-flat-button class="btn" [class.btn-primary]="true" (click)="openFileDialog()">選擇 CSV 文件</button>
      <input type="file" #fileInput (change)="onFileSelected($event)" style="display: none;" accept=".csv">
      <textarea [value]="csvContent" readonly></textarea>
    </div>
    <app-jkdaterange #coptc003 id="coptc003" label="日期範圍" [(valueA)]="dateA" [(valueB)]="dateB"
    [showClearButton]="true" (valueAChange)="onValueChangeA($event)" (valueBChange)="onValueChangeB($event)">
  </app-jkdaterange>
</mat-tab>
  <mat-tab #myTabDetail label="詳細資料">
    <!-- (rowClicked)="gridMain.agRowClicked($event)"
    (rowSelected)="gridMain.agRowSelected($event)"  -->
    <app-jkgridwin #jkgridwin
      (afterGridReady)="afterGridReady($event)"></app-jkgridwin>
  </mat-tab>
</mat-tab-group>

